<template>
  <div class="form-group">
    <label v-if="showLabel" class="active-select px-2" for="">{{
      label
    }}</label>
    <div class="device-select" v-click-outside="handleHide">
      <div class="position-relative">
        <input
          type="text"
          @input="$emit('doSearch', $event)"
          class="font-16 device-select form-control"
          :style="(!multi && selected.length == 1) ? 'cursor: not-allowed' : ''"
          :placeholder="placeholder"
          style="min-height: 2.3rem; width: 100%; padding-left: 40px"
          @focus="handleFocus"
          :disabled="isDisabled || (!multi && selected.length == 1)"
        />
        <div v-if="showValues" class="selected__container">
          <span
            class="selected"
            v-for="{ value, id } in selected.slice(0, 2)"
            :key="id"
          >
            <span>
              {{ value }}
            </span>
            <button
              class="remove__btn"
              @click="$emit('removeItem', id)"
              type="button"
            >
              <span>x</span>
            </button>
          </span>
          <span v-if="selected.length > 2">+{{ selected.length - 2 }}</span>
        </div>
        <i
          class="fas fa-search fa-lg position-absolute"
          style="
            top: 50%;
            transform: translateY(-50%);
            left: 10px;
            color: #b7c3cd;
          "
        ></i>
        <i
          v-if="isLoading"
          class="fas fa-spinner fa-spin position-absolute"
          style="
            top: 35%;
            transform: translateY(-50%);
            right: 10px;
            color: #b7c3cd;
          "
        ></i>      </div>
      <div
        class="dropdown"
        :style="data.length > 2 && 'overflow-y:auto'"
        v-show="show"
      >
        <div v-if="isLoading" class="text-center py-3">
          <i class="fas fa-spinner fa-spin" style="color: #b7c3cd; font-size: 1.2rem;"></i>
          <p class="mt-2 mb-0 gray4">Searching...</p>
        </div>
        <template v-else>
          <div v-if="data.length > 0">
            <div class="check-devices d-flex mb-2" v-if="multi">
              <input
                type="checkbox"
                :checked="isSelectAll"
                name="selected-device"
                @click="isSelectAll ? deSelectAll() : selectAll()"
                :id="label.toLowerCase().replace(' ', '-')"
                class="cursor-pointer"
              />
              <label
                :for="label.toLowerCase().replace(' ', '-')"
                class="gray4 mb-0 font-16 cursor-pointer"
                style="margin-left: 0.7rem; font-weight: 100"
                >{{ !isSelectAll ? $t("sel_all") : $t("desel_all") }}</label
              >
            </div>
            <div
              class="check-devices d-flex mb-2"
              v-for="(item, i) in data"
              :key="i"
            >
              <input
                :type="multi ? 'checkbox' : 'radio'"
                :checked="isItemChecked(item)"
                :id="`${prefix}-${item.id || item.name}`"
                name="selected-device"
                @click="handleItemClick(item)"
                class="cursor-pointer checkbox"
              />
              <label
                :for="`${prefix}-${item.id || item.name}`"
                class="gray4 mb-0 font-16 cursor-pointer"
                style="margin-left: 0.7rem; font-weight: 100"
                >{{ item.name }}</label
              >
            </div>
          </div>
          <div v-else>
            <h4 class="text-center mb-0 gray4">
              {{ $t("no_result_found") }}
            </h4>
          </div>
        </template>
      </div>
    </div>
    <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "ComboBox",
  data() {
    return {
      key: "",
      show: false,
    };
  },
  props: {
    data: Array,
    isLoading: {
      type: Boolean,
      default: false,
    },
    isSelectAll: Boolean,
    isItemChecked: Function,
    deSelectAll: Function,
    selectAll: Function,
    isDisabled: Boolean,
    showValues: Boolean,
    selected: Array,
    errorMessage: String,
    prefix: {
      type: String,
      default: function () {
        return this.$t("devices");
      },
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t("search");
      },
    },
    label: {
      type: String,
      default: function () {
        return this.$t("search");
      },
    },
    // when false, component acts like single-select. default is multi-select
    multi: {
      type: Boolean,
      default: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    handleItemClick(item) {
      this.$emit("checkClick", item);
      if (!this.multi) {
        this.show = false;
      }
    },
    handleHide() {
      this.show = false;
    },
    handleFocus() {
      console.log(this.isDisabled, "isDisabled");

      if (!this.isDisabled) this.show = true;
    },
  },
};
</script>

<style>
.dropdown {
  max-height: 10.3rem;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  padding: 12px 16px 16px 16px;

  position: absolute;
  width: 100%;
  z-index: 300;
}
.selected__container {
  display: flex;
  align-items: center;
  gap: 4px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  max-width: 450px;
  overflow: auto;
}
.selected {
  background: #fff;
  padding: 8px;
  border: 1px solid #b7c3cd;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
}
.remove__btn {
  background: #404a57;
  padding: 5px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 14px;
  max-height: 14px;
  font-size: 10px;
  font-weight: 600;
  position: relative;
}
.remove__btn span {
  transform: translateY(-1px);
}
.error {
  color: red;
  font-size: 12px;
}
</style>
